import { PointsImageEditorView } from '@/features/image-editor/views/PointsImageEditorView'
import { Button } from '@/ui/atoms/button/Button'
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '@/ui/atoms/dialog/Dialog'
import { Share } from 'lucide-react'

export function ImageDownloadDialog({ points, rank }: { points: number; rank: number }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" className="font-normal text-muted-foreground text-sm">
          Share
          <Share className="ml-1 h-3.5 w-3.5" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogTitle gradient className="self-start">
          Download image
        </DialogTitle>

        <div className="mt-6">
          <PointsImageEditorView points={points} rank={rank} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
